<template>
    <div v-if="$store.state.isCheckingIfLoggedIn" />
    <v-btn
        v-else-if="!$store.state.isLoggedIn"
        color="primary"
        class="font-weight-bold"
        :to="loginLink"
    >
        {{$translate('Log in')}}
    </v-btn>

    <zoezi-user-avatar v-else :user="$store.state.user" class="z-clickable" @click="clicked" :size="48" />
</template>

<script>
import ZoeziUserAvatar from '../components/UserAvatar.vue'
export default {
    name: 'zoezi-account-button',

    zoezi: {
        title: 'Account button',
        icon: 'mdi-account-circle'
    },

    components: {
        ZoeziUserAvatar
    },

    props: {
        loginLink: {
            title: 'Login link',
            type: String,
            fulltype: 'page',
            default: '/login'
        }
    },

    methods: {
        clicked() {
            if (this.$root.edit) {
                this.$emit('select', this);
            } else {
                let link = this.$root.getDefaultPage('mypages');
                if (this.$route.path != link) {
                    this.$router.push({path: link});
                    this.$store.commit('setShowMobileMenu', false);
                }
            }
        }
    }
}
</script>
